export const environment = {
	production: true,
	backend: 'https://microsites-fs1.appspot.com/api/v1/',
};
